import { TodaysEscapesScheduleGenerationSegment } from '~/queries/customerCommunication/requestPostTodaysEscapesScheduleGeneration';

import { LE_AGENT_HUB, LUXURY_ESCAPES } from '~/consts/brands';

// typed against the contract so a renamed or removed segment fails the build
export const LIFESTYLE_GENERATION_SEGMENTS: Array<{ id: TodaysEscapesScheduleGenerationSegment; name: string }> = [
  { id: 'TRAVEL', name: 'Travel' },
  { id: 'EXPERIENCE', name: 'Experience' },
];

/**
 * Lifestyle brands generate (and pre-send check) their travel and experience sends separately, so the backend needs
 * one of the segments; Luxury Escapes and LeAgentHub handle the whole country group at once.
 */
export function requiresHeroPlannerGenerationSegment(brand: string) {
  return brand !== LUXURY_ESCAPES && brand !== LE_AGENT_HUB;
}

/** The segments to run generation or the pre-send check for; `undefined` means the whole country group */
export function getHeroPlannerGenerationSegments(
  brand: string,
): Array<TodaysEscapesScheduleGenerationSegment | undefined> {
  return requiresHeroPlannerGenerationSegment(brand)
    ? LIFESTYLE_GENERATION_SEGMENTS.map((segment) => segment.id)
    : [undefined];
}

export function getHeroPlannerGenerationSegmentName(segment: string) {
  return LIFESTYLE_GENERATION_SEGMENTS.find((option) => option.id === segment)?.name ?? segment;
}
